import React, { useState, forwardRef, useRef, useImperativeHandle } from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import { secondsToTime } from "../utilities/scoringUtilities";

import Button from 'react-bootstrap/Button';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useEffect } from "react";
import { useLocation  } from 'react-router';
import queryString from 'query-string'
import { useSelector, useDispatch } from 'react-redux'

//todo
//move all skips to methods
//add keypress methods
//make global
//https://stackoverflow.com/questions/29069639/listen-to-keypress-for-document-in-reactjs


const SHIFT_KEY = 16;
const SPACE_KEY = 32;
const LEFT_ARROW_KEY = 37;
const RIGHT_ARROW_KEY = 39;
const P_KEY = 80;

export const VideoJS = forwardRef((props, ref) => {

    const dispatch = useDispatch()
    let state = useSelector(state => state)

    let videoTime = state.videoTime

    const videoRef = React.useRef(null);
    const playerRef = React.useRef(null);
    const { options, onReady, height, maxHeight, isModalOpen } = props;

    const [isPaused, setIsPaused] = useState(false);

    const [isShiftHeld, setIfShiftHeld] = useState(false);

    useImperativeHandle(ref, () => ({
        pauseVideo() {
            playerRef.current.pause();
        },
        setVideoTime(time) {
            playerRef.current.currentTime(time)
        }
    }));

    const togglePictureInPicture = () => {
        try {
            if (playerRef && playerRef.current && playerRef.current.requestPictureInPicture) {
                if (document.pictureInPictureElement) {
                    document.exitPictureInPicture();
                } else {
                    playerRef.current.requestPictureInPicture();
                }
            }
        } catch (ex) {
            console.log(ex);
        }
    }

    useEffect(() => {
        let handleKeyDown = (event) => {
            switch (event.keyCode) {
                case SHIFT_KEY:
                    setIfShiftHeld(true);
                    break;
                case LEFT_ARROW_KEY:
                    if (isModalOpen){
                        playerRef.current.pause();
                    }
                    else if (isShiftHeld)
                        playerRef.current.currentTime(playerRef.current.currentTime() - 10);
                    else
                        playerRef.current.currentTime(playerRef.current.currentTime() - 5);
                    break;
                case RIGHT_ARROW_KEY:
                    if (isModalOpen){
                        playerRef.current.pause();
                    }
                    else if (isShiftHeld)
                        playerRef.current.currentTime(playerRef.current.currentTime() + 10);
                    else
                        playerRef.current.currentTime(playerRef.current.currentTime() + 5);
                    break;
                case SPACE_KEY:
                    if(!isModalOpen){
                        if (playerRef.current.paused()) {
                            playerRef.current.play();
                        }
                        else {
                            playerRef.current.pause();
                        }                        
                    }
                case P_KEY:
                    if (isShiftHeld) {
                        togglePictureInPicture();
                    }
                default:
                    break;
            }
        };

        let handleKeyUp = (event) => {
            switch (event.keyCode) {
                case SHIFT_KEY:
                    setIfShiftHeld(false);
                    break;
                default:
                    break;
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("keyup", handleKeyUp);

        return function cleanup() {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("keyup", handleKeyUp);
        };
    });

    function timeUpdate() {
        dispatch({
            type: 'UPDATE_VIDEO_TIME', videoTime: playerRef.current.currentTime(),
        });
    };

    React.useEffect(() => {
        // make sure Video.js player is only initialized once
        if (!playerRef.current) {
            const videoElement = videoRef.current;
            if (!videoElement) return;

            const player = playerRef.current = videojs(videoElement, options, () => {
                onReady && onReady(player);

                player.on('timeupdate', timeUpdate);

                player.on("pause", () => {
                    setIsPaused(true);
                });

                player.on("play", () => {
                    setIsPaused(false);
                });

            });
        } else {
            // you can update player here [update player through props]
            // const player = playerRef.current;
            // player.autoplay(options.autoplay);
            // player.src(options.sources);
        }
    }, [options, videoRef, videoTime]);

    // Dispose the Video.js player when the functional component unmounts
    React.useEffect(() => {
        const player = playerRef.current;

        return () => {
            if (player) {
                player.dispose();
                playerRef.current = null;
            }
        };
    }, [playerRef]);

    const { search } = useLocation();

    React.useEffect(()=>{
        const values = queryString.parse(search)
        playerRef.current.currentTime(parseFloat(values.time));
    },[])

    let centerButton = isPaused ? <i className="fas fa-solid fa-play" style={{ paddingRight: "2px" }}></i> : <i className="fas fa-solid fa-pause"> </i>;

    return (
        <>
            <Row className="my-1">
                <Col sm="3">
                    <h5>
                        {playerRef && playerRef.current &&
                            <span className="align-bottom">{secondsToTime(playerRef.current.currentTime())}</span>
                        }
                    </h5>
                </Col>
                <Col sm="9">
                    <Button variant="secondary" className="mr-1" onClick={() => {
                        playerRef.current.currentTime(playerRef.current.currentTime() - 10)
                    }}>
                        <i className="fas fa-solid fa-backward-fast"></i>
                    </Button>

                    <Button variant="secondary" className="mr-1" onClick={() => {
                        playerRef.current.currentTime(playerRef.current.currentTime() - 5);
                    }}>
                        <i className="fas fa-solid fa-backward-step"></i>
                    </Button>

                    <Button variant="secondary" className="mr-1" onClick={() => {
                        if (playerRef.current.paused()) {
                            playerRef.current.play();
                        }
                        else {
                            playerRef.current.pause();
                        }
                    }}>
                        {centerButton}
                    </Button>

                    <Button variant="secondary" className="mr-1" onClick={() => {
                        playerRef.current.currentTime(playerRef.current.currentTime() + 5)
                    }}>
                        <i className="fas fa-solid fa-forward-step"></i>
                    </Button>

                    <Button variant="secondary" className="mr-1" onClick={() => {
                        playerRef.current.currentTime(playerRef.current.currentTime() + 10)
                    }}>
                        <i className="fas fa-solid fa-forward-fast"></i>
                    </Button>

                    <Button variant="secondary" className="ml-1 float-right" onClick={() => {
                        togglePictureInPicture();
                    }}>
                        <i className="fas fa-solid fa-clone"></i>
                    </Button>
                </Col>
            </Row>
            <div data-vjs-player>
                <video ref={videoRef} className="video-js vjs-big-play-centered"  />
            </div>
        </>
    );
})

export default VideoJS;